import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { deleteIdData,updateData } from "../../../lib/studentchecklist";
import { getStudentIdData } from "../../../lib/studentchecklistview";

const URGENCY = {
  Must: "Must",
  Should: "Should",
  BetterHave: "Better Have",
};

const urgencyColors = {
  Must: "table-danger",
  Should: "table-warning",
  BetterHave: "table-info",
};

export default function GlobalCheckList({ slug, isStudent }) {
  const [tasklist, setTasklist] = useState([]);
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      getDatafromCheckList();
      console.log("Delete", id);
      //router.refresh();
    }
  };

  async function ChangeProgress(Id, isProgress) { 
    await updateData({
      id: Id,
      isProgress: !isProgress,
    });
    getDatafromCheckList();
  }

  async function ChangeDone(Id, isDone) { 
    await updateData({
      id: Id,
      isDone: !isDone,
    });
    getDatafromCheckList();
  }

  async function getDatafromCheckList() {
    const tasks = await getStudentIdData(slug);
    console.log("tasks: ", tasks);
    const sortedTasklist = [...tasks].sort((a, b) => a.id - b.id);
    setTasklist(sortedTasklist);
  }

  useEffect(() => {
    getDatafromCheckList();
  }, [setTasklist]);

  useEffect(() => {
    getStudentIdData(slug)
      .then((data) => setTasklist(data))
      .catch((error) =>
        console.error("There was an error fetching the task list!", error)
      );
  }, [slug]);

  return (
    <div className="col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-1 pe-3">
          {/* <div className="container mt-1"> */}
            <div className="d-flex justify-content-between align-items-center">
            <div >
              <h4 className="px-3">Check List

              <button
                type="button"
                className="btn btn-outline-info mx-2"
                data-bs-toggle="collapse"
                data-bs-target="#collapseCheckList"
                aria-expanded="false"
                aria-controls="collapseCheckList"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  fill="currentColor"
                  className="bi bi-chevron-double-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                  <path
                    fillRule="evenodd"
                    d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </button>

              </h4>
            </div>
              <div>
                {isStudent ? (
                  // <button
                  //   className="btn btn-dark btn-dark-1"
                  //   onClick={() =>
                  //     navigate(`/student12/student-checklist-edit/${slug}/Add/0`)
                  //   }
                  // >
                  //   Add Task
                  // </button>
                  ""
                ) : (
                  <button
                    className="btn btn-dark btn-dark-1"
                    onClick={() =>
                      navigate(
                        `/instructor/instructor-checklist-edit/${slug}/Add/0`
                      )
                    }
                  >
                    <h8>Add New Item</h8>                   
                  </button>
                )}
              </div>
            </div>
            <div className="p2 collapse" id="collapseCheckList">
            <table className="table table-hover p-1">
              <thead className="align-text-center">
              <tr>
            <th scope="col" className="text-left" style={{ width: '8.33%' }}>Time Frame</th>
            <th scope="col" className="text-center" style={{ width: '8.33%' }}>Urgency</th>
            <th scope="col" className="text-center" style={{ width: '41.67%' }}>Task</th>
            <th scope="col" className="text-center" style={{ width: '8.33%' }}>Date</th>
            <th scope="col" className="text-center" style={{ width: '8.33%' }}>Done</th>
            <th scope="col" className="text-center" style={{ width: '8.33%' }}>In Progress</th>
            {!isStudent ? (
            <th scope="col" className="text-center" style={{ width: '16.67%' }}>Action</th>
            ) : null}
          </tr>
              </thead>
              <tbody className="m-1">
                {tasklist.map((data) => (
                  <tr key={data.id} className={urgencyColors[data.urgency]}>
                    <td className="p-1">{`${data.startMonth} - ${data.endMonth}`}</td>
                    <td>{data.urgency}</td>
                    <td className="text-start" >{data.pname}</td>
                    <td>{data.tDate}</td>
                    <td className="text-center" >
                    {isStudent ? (
                        <input
                          type="checkbox"
                          checked={data.isDone}
                          onChange={(e) => ChangeDone(data.id, data.isDone)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          checked={data.isDone}
                          readOnly
                        />
                      )}
                    </td>
                    <td className="text-center" >
                      {isStudent ? (
                        <input
                          type="checkbox"
                          checked={data.isProgress}
                          onChange={(e) => ChangeProgress(data.id, data.isProgress)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          checked={data.isProgress}
                          readOnly
                        />
                      )}
                    </td>
                    {isStudent ? (
                          ""
                        ) : (
                     <td className="p-1">
                      <div className="profile-share d-flex align-items-center justify-content-end">
                       
                          <Link
                            to={`/instructor/instructor-checklist-edit/${slug}/Update/${data.id}`}
                            className="btn btn-success btn-sm"
                          >
                            Update
                          </Link>
                          <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDelete(data.id)}
                        >
                          Delete
                        </button>
                        
                        
                        
                      </div>
                    </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>
        </div>
      {/* </div> */}
    </div>
  );
}
